export const ageList = [
  { value: 'months', label: 'months', id: 1 },
  { value: 'years', label: 'years', id: 2 },
];
